export const BOOTSTRAP_COMPANIES = 'BOOTSTRAP_COMPANIES'
export const SET_SELECTED_COMPANY = 'SET_SELECTED_COMPANY'
